const PREFIX = 'flags'

export function setFlag (name, value, prefix = PREFIX) {
  localStorage.setItem(`${prefix}.${name}`, value)
}

export function getFlag (name, defaultValue = null, prefix = PREFIX) {
  let value = localStorage.getItem(`${prefix}.${name}`)
  return (value === null || value === undefined)
    ? defaultValue
    : (value === 'true')
      ? true
      : (value === 'false')
        ? false
        : value
}

export function removeFlag (name, prefix = PREFIX) {
  localStorage.removeItem(`${prefix}.${name}`)
}

export default {
  setFlag,
  getFlag,
  removeFlag,
}

if (!window.booksy) {
  window.booksy = {}
}

window.booksy.getFlag = getFlag
window.booksy.setFlag = setFlag
